import React from "react";
import MainDashboardLayout from "../../../Layout/MainDashboardLayout";
import GeneralInstructions from "./GeneralInstructions";
import BRSRSidebar from "../../../Layout/BRSRSidebar";
import Unauthorized from "../../../Components/Unauthorized/Unauthorized";

const BRSRindex = () => {
  return (
    <MainDashboardLayout sidebar={<BRSRSidebar />}>
      <Unauthorized requiredModule="ESG Reporting |BRSR">
        <GeneralInstructions />
      </Unauthorized>
    </MainDashboardLayout>
  );
};

export default BRSRindex;
